import { render, staticRenderFns } from "./Importe.vue?vue&type=template&id=199aa2a6&"
import script from "./Importe.vue?vue&type=script&lang=js&"
export * from "./Importe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports